import React from 'react';
import { TextField } from 'react-admin';

import Datagrid from '../common/Datagrid';
import CountryField from '../common/fields/CountryField';
import DateField from '../common/fields/DateField';
import ResourceLinkField from '../common/fields/ResourceLinkField';
import RecordSplitButton from '../common/buttons/RecordSplitButton';


const CompanyRow = ({ children, ...props }) => (
	<Datagrid {...props}>
		<ResourceLinkField label="Name" resource="companies">
			<TextField source="name" />
		</ResourceLinkField>
		<CountryField source="country" />
		<DateField source="updated_at" />
		<RecordSplitButton />
		{children}
	</Datagrid>
);

export default CompanyRow;